import React, {Component} from 'react';
import FlatButton from 'material-ui/FlatButton';
import Dialog from 'material-ui/Dialog';
import {deleteCard, putCards} from "store/cards/actions";
import {connect} from 'react-redux'
import {translate} from "react-i18next";

class CardDeleteDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
        };
    }

    handleOpen = () => {
        this.setState({
            open: true
        })
    };

    handleClose = () => {
        this.setState({open: false});
    };

    handleSubmit = () => {
        this.props.handleSubmit(this.props.card)
    };

    render() {
        const actions = [
            <FlatButton
                label={this.props.t('dialog_dismiss')}
                // primary={true}
                onClick={this.handleClose}
                key="cancel"
            />,
            <FlatButton
                label={this.props.t('dialog_delete')}
                primary={true}
                key="submit"
                onClick={this.handleSubmit}
                // onClick={this.handleClose}
            />,
        ];

        const Wrapper = this.props.wrapper;
        const text = this.props.t('delete_card_dialog_text', {1: this.props.card.n_word, 2: this.props.card.f_word })
        const title = this.props.t('package_management_dialog_delete_title');
        return (
            <Wrapper {...this.props.wrapperProps} onClick={(e) => {e.stopPropagation(); this.handleOpen()}}>
                delete
                <Dialog autoScrollBodyContent={true} open={this.state.open} title={title}>
                    <p>{text}</p>
                    <div style={{textAlign: 'right', padding: 8, margin: '24px -24px -24px -24px'}}>
                        {actions}
                    </div>
                </Dialog>
            </Wrapper>
        )
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        handleSubmit: (card) => {
            dispatch(deleteCard(card));
            dispatch(putCards());
        }
    }
};

export default connect(null, mapDispatchToProps)(translate()(CardDeleteDialog));



// WEBPACK FOOTER //
// ./src/components/packages/CardDeleteDialog.js